import { INVALID_USER_NAME_OR_PASSWORD } from '~/assets/strings';
import { Presenter } from '~/framework/Presenter';
import { User } from '~/state/mainAppState';

export interface PresentableStatus {
  isLoggedIn: boolean;
  errorMessage?: string;
}

export class LoggedInStatusPresenter extends Presenter<PresentableStatus> {
  protected createModel = (state: User): PresentableStatus => {
    return {
      isLoggedIn: state.loginInfo.isLoggedIn,
      errorMessage: state.loginInfo.error ? INVALID_USER_NAME_OR_PASSWORD : undefined,
    };
  };
}
